module.exports = __webpack_public_path__ + "static/media/Tag-2.2314247a.png";